module.exports = __webpack_public_path__ + "static/img/11.fd8662f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/jpg/11.jpg
// module id = 71rL
// module chunks = 1